import { DataService } from './dataService'

export const customerServiceService = {

    addCustomerService: async (data) => {
        return DataService.post('/admin/add_sales_customer', data)
    },
    getCustomerService : async (data) => {
        return DataService.get('/admin/employee/get_customer_service', data)
    },
    // getCustomerList : async (data) => {
    //     return DataService.get('/get_sales_customer', data)
    // },
    CustomerServiceList: async (data) => {
        return DataService.get('/admin/get_sales_customer', data)
    },
    singleCustomerService: async (id) => {
        return DataService.get('/admin/get_single_sales_customer?Id='+ id)
    },
    updateCustomerService: async (data) => {
        return DataService.post('/admin/update_sales_customer', data)
    },
    deleteCustomerService: async (data) => {
        return DataService.post('/admin/remove_sales_customer', data)
    },    
}
